var map = {
	"./CommonFarms.json": 46947,
	"./ERC20.json": 21871,
	"./EarnOtherFixedAPR.json": 59214,
	"./EarnOtherFixedAPRLock.json": 2401,
	"./EarnOtherFixedAPRLockRewardWithChangeableRatio.json": 57201,
	"./EarnOtherNoFixedAPR.json": 44157,
	"./Farms.json": 14088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63964;